import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PackingRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.packing_order_create === true ||
    permissions.packing_order_edit === true ||
    permissions.packing_order_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default PackingRouteMiddleware;
